import {
    IContactLens,
    IMySavedPrescriptionItem,
    IMySavedPrescriptionsList,
} from '@interfaces/contactsInterfaces';
import * as actionTypes from './actionTypes';

export const saveContactLensesData = (currentProduct: IContactLens) => {
    return {
        type: actionTypes.SAVE_CONTACT_LENSES_DATA,
        currentProduct: currentProduct,
    };
};

export const addToCartPending = () => {
    return {
        type: actionTypes.ADD_TO_CART_PENDING,
    };
};

export const addToCartSuccess = () => {
    return {
        type: actionTypes.ADD_TO_CART_SUCCESS,
    };
};

export const addToCartError = () => {
    return {
        type: actionTypes.ADD_TO_CART_ERROR,
    };
};

export const getMySavedPrescriptionsPending = () => {
    return {
        type: actionTypes.GET_MY_SAVED_PRESCRIPTIONS_PENDING,
    };
};

export const getMySavedPrescriptionsSuccess = (mySavedPrescriptions: IMySavedPrescriptionsList) => {
    return {
        type: actionTypes.GET_MY_SAVED_PRESCRIPTIONS_SUCCESS,
        mySavedPrescriptions: mySavedPrescriptions,
    };
};

export const getMySavedPrescriptionsError = () => {
    return {
        type: actionTypes.GET_MY_SAVED_PRESCRIPTIONS_ERROR,
    };
};

export const setCurrentPrescription = (currentPrescription: IMySavedPrescriptionItem) => {
    return {
        type: actionTypes.SET_CURRENT_PRESCRIPTION,
        currentPrescription: currentPrescription,
    };
};
